import React, {useCallback, useRef, useState} from 'react';
import {formatInTimeZone} from 'date-fns-tz';
import isBefore from 'date-fns/isBefore';
import Image from 'next/image';
import Link from 'next/link';
import dynamic from 'next/dynamic';

import ShortDescription from '@components/product/StoreDetail/ShortDescription';
const Animation = dynamic(() =>
	import('@components/product/StoreDetail/Animation'),
);

function StoreDetail(props) {
	const getTime = time => {
		return formatInTimeZone(time, '', 'dd MMMM yyyy');
	};
	const {styles, retailer} = props;
	const [data, setData] = useState({
		showLess: false,
	});
	const storeRef = useRef({});

	//const descriptionRef = useRef({});

	const showHideDescription = useCallback(() => {
		if (!data.showLess) {
			storeRef.current.style.height = storeRef.current.clientHeight + 'px';
			setTimeout(() => {
				storeRef.current.style.height = '150px';
				storeRef.current.style.overflow = 'hidden';
				setData(prev => ({...prev, showLess: !prev.showLess}));
			}, 10);
		} else {
			storeRef.current.style.height = 'auto';
			storeRef.current.style.overflow = 'visible';
			setData(prev => ({...prev, showLess: !prev.showLess}));
		}
	}, [data.showLess]);

	const showMoreText = (
		<>
			<span onClick={showHideDescription} className={styles.showLess}>
				+ Show More
			</span>
		</>
	);
	const showLessText = (
		<>
			<span onClick={showHideDescription} className={styles.showLess}>
				- Show Less
			</span>
		</>
	);

	return (
		<div
			className={`storeCol ${styles.bannerStore} ${
				data.showLess ? 'false' : 'show'
			}`}
			ref={storeRef}
		>
			<div className={styles.storeBannerImage}>
				{retailer?.shop_image && (
					<Image
						layout='fill'
						objectFit='contain'
						className={styles.image}
						src={retailer?.shop_image}
						alt={retailer?.shop_name}
						quality={100}
						priority={true}
					/>
				)}
				{(retailer?.shop_desc ||
					retailer?.video_url ||
					retailer?.freeExpressShippingAbove ||
					retailer?.freeStandardShippingAbove ||
					retailer?.freeInternationalShippingAbove ||
					retailer?.freeSendleShippingAbove ||
					retailer?.promotions.length > 0) &&
					(data.showLess ? showMoreText : showLessText)}
			</div>
			{retailer?.retailerDonation &&
				isBefore(new Date(), new Date(retailer?.retailerDonation?.end_date)) &&
				retailer?.retailerDonation?.good_cause &&
				retailer?.retailerDonation?.good_cause.isActive &&
				retailer?.retailerDonation?.good_cause._id && (
					<div className={styles.goodCauseDetails}>
						<b>{retailer?.shop_name}</b> will make a bonus donation to{' '}
						<b>{retailer?.retailerDonation?.good_cause?.registeredAbnName}</b>{' '}
						when you purchase their products on Better That! Check out the
						individual product details for more info. Hurry, this offer ends on{' '}
						<b>{getTime(retailer?.retailerDonation?.end_date)}</b>.
					</div>
				)}

			<div className={styles.descriptionOuter}>
				{/* {retailer?.shop_desc && (
					<div className={`${styles.pageHeading}`}>
						<ShortDescription
							heightVal={60}
							text={retailer?.shop_desc}
							descriptionRef={descriptionRef}
						/>
					</div>
				)} */}

				<ShortDescription text={retailer?.shop_desc} styles={styles} />

				{retailer?.video_url && (
					<div className={styles.videoBlock}>
						<iframe
							src={`https://player.vimeo.com/video/${retailer?.video_url}?title=0&byline=0&portrait=0&badge=0`}
							width='560'
							height='349'
							frameBorder='0'
							allowFullScreen
						></iframe>
					</div>
				)}
			</div>

			{retailer?.storeDetail && retailer?.storeDetail?.isChecked && (
				<React.Fragment>
					<div className={styles.licenseNumber}>
						<b>{retailer.shop_name}</b>
						<br />
						<br />
						{/* {' - Liquor License No : '} */}
						{retailer?.storeDetail?.licensefile ? (
							<>
								{retailer?.storeDetail.licenseNumber} &nbsp;
								<Link href={retailer?.storeDetail.licensefile} passHref>
									<a target='_blank' rel='noopener noreferrer'>
										View license here
									</a>
								</Link>
							</>
						) : (
							retailer?.storeDetail.licenseNumber
						)}
					</div>
					<br />
					<br />
					<div className={styles.alocholBlock}>
						<div
							dangerouslySetInnerHTML={{
								__html: retailer?.storeDetail?.additonalInfo,
							}}
						></div>
					</div>
				</React.Fragment>
			)}

			{(retailer?.freeExpressShippingAbove ||
				retailer?.freeStandardShippingAbove ||
				retailer?.freeInternationalShippingAbove ||
				retailer?.freeSendleShippingAbove ||
				retailer?.promotions.length > 0) && (
				<div className={styles.spacial}>
					<span className={styles.spacialHeading}>
						Special offers for this store
					</span>
					{!!retailer && <Animation retailer={retailer} />}
				</div>
			)}
		</div>
	);
}

export default StoreDetail;
